// @flow
import env from '../../../environment';
import {
  deleteCreator,
  getCreator,
  postCreator,
  putCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  CREATE_POST: `${env.baseApiUrl}/ui/admin/store/blog/post`,
  GET_LIST_POSTS: `${env.baseApiUrl}/ui/admin/store/blog/post`,
  GET_POST: `${env.baseApiUrl}/ui/admin/store/blog/post/:postId`,
  EDIT_POST: `${env.baseApiUrl}/ui/admin/store/blog/post/:postId`,
  DELETE_POST: `${env.baseApiUrl}/ui/admin/store/blog/post/:postId`,
});
export type BlogPostFilter = {
  search?: string,
  enabled?: boolean,
  authors?: string[],
  categories?: string[],
  title?: string,
};

export type BlogPostSection = {
  title?: string,
  content?: string,
  image1Id?: string,
  image1Description?: string,
  image2Id?: string,
  image2Description?: string,
  enabled?: boolean,
};

type BlogObjectRelated = {
  blogEntityType: 'PRODUCT' | 'CATEGORY' | 'SUBCATEGORY',
  entityIdentifier: string,
};

export type CreateBlogPost = {
  title: string,
  author?: {
    id?: string,
    name: string,
  },
  slug: string,
  isCustomSlug?: boolean,
  mainImageId: string,
  mainImageDescription?: string,
  seoTitle?: string,
  seoContent?: string,
  enabledRelatedEntities?: boolean,
  enabled: boolean,
  sections: BlogPostSection[],
  relatedEntities?: BlogObjectRelated[],
  categories: string[],
  featured?: boolean,
};
export type EditBlogPost = $Shape<CreateBlogPost>;

export const createPostApi = postCreator(endpoints.CREATE_POST);
export const listPostsApi = getCreator(endpoints.GET_LIST_POSTS);
export const getPostApi = getCreator(endpoints.GET_POST);
export const editPostApi = putCreator(endpoints.EDIT_POST);
export const deletePostApi = deleteCreator(endpoints.DELETE_POST);
